import apiClient from './client'

export const notificationService = {
  getNotifications: () => apiClient.get('/notifications'),

  getUnreadCount: () => apiClient.get('/notifications/unread-count'),

  markAsRead: (id) => apiClient.put(`/notifications/${id}/read`),

  markAllRead: () => apiClient.put('/notifications/mark-all-read'),

  deleteNotification: (id) => apiClient.delete(`/notifications/${id}`),
}

export default notificationService
